const doc = [({"da":({"js":({"merfoto":({"basket":({"unique_photos_label":({"photo_s":"Foto(s)"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;